import React, { Component, Fragment } from 'react';
import { Alert, Button } from 'react-bootstrap';

class AlertDismissable extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      show: false
    };
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.show !== this.state.show){
      this.setState({show: nextProps.show});
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    error = TransHelper.translate(this.props.locale, "content.common.somethingWrong");
    const { description = error } = this.props;

    if (this.state.show) {
      return (
        <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
          <p>
            { description }
          </p>
        </Alert>
      );
    }

    return <span />;
  }
}

export default AlertDismissable;